import axios from "axios";
import { useCallback } from "react";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const publicApi = axios.create({ baseURL: API });

const TOKEN_KEY = "himma_token";
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => (t ? localStorage.setItem(TOKEN_KEY, t) : localStorage.removeItem(TOKEN_KEY));

export function useApi() {
  return useCallback(async (method, url, data, opts = {}) => {
    const t = getToken();
    const r = await axios({ method, url: API + url, data, headers: t ? { Authorization: `Bearer ${t}` } : {}, ...opts });
    return r.data;
  }, []);
}

export function useDownload() {
  const api = useApi();
  return useCallback(
    async (url, filename) => {
      const blob = await api("get", url, null, { responseType: "blob" });
      const href = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = href;
      a.download = filename;
      a.click();
      setTimeout(() => URL.revokeObjectURL(href), 2000);
    },
    [api],
  );
}

export const fileUrl = (u) => (!u ? "" : u.startsWith("/api/") ? BACKEND_URL + u : u);

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (Array.isArray(d)) return d.map((x) => String(x.msg || "").replace("Value error, ", "")).join("، ");
  return d || "حدث خطأ غير متوقع، حاول مرة أخرى";
};

export const fmtPrice = (n) => `${Number(n || 0).toFixed(3).replace(/\.?0+$/, "")} ر.ع.`;

export const fmtDate = (d) =>
  d ? new Date(`${d}T00:00:00`).toLocaleDateString("ar-OM-u-nu-latn", { weekday: "long", year: "numeric", month: "long", day: "numeric" }) : "";

export const fmtDateTime = (iso) =>
  iso ? new Date(iso).toLocaleString("ar-OM-u-nu-latn", { year: "numeric", month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" }) : "—";

export const fmtTime = (t) => {
  if (!t) return "";
  const [h, m] = t.split(":").map(Number);
  const h12 = h % 12 || 12;
  return `${h12}:${String(m).padStart(2, "0")} ${h >= 12 ? "مساءً" : "صباحاً"}`;
};

export const STATUS = {
  pending_payment: { label: "بانتظار الدفع", cls: "bg-amber-100 text-amber-800" },
  confirmed: { label: "مؤكد", cls: "bg-emerald-100 text-emerald-800" },
  payment_failed: { label: "فشل الدفع", cls: "bg-red-100 text-red-700" },
  cancelled: { label: "ملغى", cls: "bg-stone-200 text-stone-700" },
  paid: { label: "مدفوع", cls: "bg-emerald-100 text-emerald-800" },
  initiated: { label: "قيد الدفع", cls: "bg-amber-100 text-amber-800" },
  failed: { label: "فشل", cls: "bg-red-100 text-red-700" },
  expired: { label: "منتهية", cls: "bg-stone-200 text-stone-700" },
};
